import { Component, OnInit, ViewChild, TemplateRef, NgZone } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { RedirectService } from "../Service/redirect.service";
import { messages } from "../shared/model/Responsemessages";
import { ShareService } from "../shared/service/share.service";
import { LoaderService } from "../shared/loader/loader.service";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../src/environments/environment";
import { StripePaymentService } from "../stripe-payment-gateway/stripe-payment.service";
import { WhatsappService } from "../whatsapp/whatsapp.service";
import { DomainService } from "../Service/domain.service";
import { StorageService } from "../Service/storage.service";
import { FeatureAccessService } from "../shared/service/feature-access.service";
import { MenuHorizontalService } from "../common-layout/service/menu-horizontal.service";
import { firstValueFrom } from 'rxjs';
import { SubscriptionPlanService } from "../shared/service/subscription-plan.service";
import { DomainTypes, SubscriptionPlanType } from '../shared/enum/environmentTypeEnum';
import { DomainType } from "../shared/service/share.service";
import { AddOnPurchaseComponent } from '../shared/common-component/add-on-purchase/add-on-purchase.component';
declare let Razorpay: any;
@Component({
  selector: "kt-email-code-form",
  templateUrl: "./email-code-form.component.html",
  styleUrls: ["./email-code-form.component.scss"],
  standalone: false
})
export class EmailCodeFormComponent implements OnInit {
  @ViewChild("paymentfailedDialog", { static: true }) paymentfailedDialog!: TemplateRef<any>;
  @ViewChild("addonFailedDialog", { static: true }) addonFailedDialog!: TemplateRef<any>;
  currentApplicationVersion = environment.appVersion;
  domain = window.location.host;

  today: number = Date.now();
  submitted = false;
  dialogRef: MatDialogRef<any>;
  name: any;
  code: any;
  id: any;
  public emailForm: FormGroup;
  emailcode: string = "";
  resData: any;
  resendCode: any = false;
  ipAddress: string;
  languageChangeSubscription: any;
  loading: boolean = false;
  Id: any;
  sessionId: any;
  paymentDetail: any;
  matdialogRef: MatDialogRef<any>;
  support = environment?.supportEmail;
  resendTimer: number = 0;
  isResendDisabled: boolean = false;
  timerInterval: any;
  loadingResend: boolean = false;
  otpExpired: boolean = false;
  showTimer: boolean;
  allowExit: boolean = false;
  isPaymentFailedDialogOpen: boolean = false;
  isSubmitDisabled = false;
  isOTPVerifiesFlow = false;
  email: string = '';
  navigationState: any;
  otpExpiryTime: number = 5 * 60; // 5 minutes in seconds
  expiryTimerInterval: any;
  selectedPlanId: number = 0;
  redirectMenu: string = '';
  bypassingOtp: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private RedirectService: RedirectService,
    private _router: Router,
    public shared: ShareService,
    public LoaderService: LoaderService,
    public translate: TranslateService,
    private dialog: MatDialog,
    private matdialogfailedRef: MatDialog,
    private redirect: RedirectService,
    private stripeService: StripePaymentService,
    private router: ActivatedRoute,
    private readonly service: WhatsappService,
    private readonly domainService: DomainService,
    private readonly storageService: StorageService,
    private readonly featureAccessService: FeatureAccessService,
    private readonly menuHorService: MenuHorizontalService,
    private readonly planService: SubscriptionPlanService,
    private readonly ngZone: NgZone
  ) {
    // this.translate.addLangs(environment?.languages);
    this.translate.setDefaultLang('en');
    this.router.queryParams.subscribe(async (params) => {
      if (params["payment_status"] == "success") {
        this.sessionId = params["session_id"];
        await this.getpaymentDetail();
        this.shared.showToast("Payment is completed", "Success");
        setTimeout(() => {
          this.AdminUserLogin(params["CompanyId"])
        }, 100);
      } else if (params["payment_status"] == "cancel") {
        this.shared.showToast("Payment is failed", "Error");
        this._router.navigate(['/']);
      }
    });
  }
  loadRazorpay() {
    const scriptId = 'razorpay-script';
    const existingScript = document.getElementById(scriptId);
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.id = scriptId;
      script.type = 'text/javascript';
      script.async = true;
      document.body.appendChild(script);
    }
  }

  ngOnInit() {
    if (!this.storageService.getItem("IA")) {
      this.redirect.getIPAddress().subscribe((x: any) => {
        const ipAddress = x.ip;
        this.ipAddress = ipAddress;
        this.storageService.setItem("IA", this.ipAddress);
      });
    }
    this.resData = sessionStorage.getItem("usercreate")
      ? JSON.parse(sessionStorage.getItem("usercreate"))
      : "";
    this.navigationState = window.history.state;

    if (this.navigationState?.bypassOtp) {
      this.bypassingOtp = true;
    }

    if (this.resData == "") {
      this.RedirectService.matchByCompanyId(this.navigationState?.CompanyId).subscribe((res: any) => {
        this.resData = res.Data;
        if ((this.isOTPVerifiesFlow || this.storageService.getItem("isForOTPVerifiedFlow") == 'true') && !this.navigationState?.bypassOtp && !this.navigationState?.DataPay) {
          this.isResendDisabled = false;
          this.storageService.setItem('selectedPlan', JSON.stringify(this.resData?.SubscriptionPlanId));
          this.storageService.setItem('planPrice', JSON.stringify(this.resData?.PlanPrice));
          this.storageService.setItem('isMonth', JSON.stringify(this.resData?.IsMonth));
          this.storageService.setItem('SelectedPlanName', this.resData?.SubscriptionPlanName);
          this.selectedPlanId = this.resData?.SubscriptionPlanId;
          this.ResendCode();
        }
      });
    }
    this.createForm();
    this.loadRazorpay();
    this.selectedPlanId = this.storageService.getItem('selectedPlan') ? JSON.parse(this.storageService.getItem('selectedPlan')) : 0;
    this.email = this.storageService.getItem("email") ?? '';
    if (this.navigationState && this.navigationState.navigationId != 1) {
      this.isOTPVerifiesFlow = this.navigationState?.IsForOTPVerifiedFlow ?? false;
      this.storageService.removeItem('resendTimer');
      this.storageService.removeItem('otpExpiryTime');
    }

    // Check if we need to bypass OTP and go straight to payment/success
    if (this.navigationState?.bypassOtp && this.navigationState?.DataPay) {
      if (this.navigationState?.JobId) {
        this.checkJobStatus(this.navigationState.JobId, this.navigationState.DataPay);
      } else {
        this.Razorpay_payment(this.navigationState.DataPay);
      }
      return;
    }

    this.startResendTimer();
    this.setOtpExpiryTime();

    const domainIdMap = {
      [DomainType.Physio]: DomainTypes.PlusPhysio,
      [DomainType.Doctor]: DomainTypes.PlusDoctor,
      [DomainType.Radiology]: DomainTypes.PlusRadiology
    };
    const domainId = domainIdMap[this.shared.domainType] || DomainTypes.PlusPhysio;
    this.planService.syncPlanIds(domainId).subscribe();
  }

  get isBasicPlan(): boolean {
    return this.planService.getPlanById(this.selectedPlanId)?.planId === SubscriptionPlanType.BasicPlan;
  }

  createForm() {
    this.emailForm = this.formBuilder.group({
      Code: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(6),
        ]),
      ],
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.emailForm.controls[controlName];
    if (!control) {
      return false;
    }
    const result =
      control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  get f() {
    return this.emailForm.controls;
  }

  validateForm() {
    for (let i in this.emailForm.controls)
      this.emailForm.controls[i].markAsTouched();
  }

  clickme() {
    if (this.otpExpired) {
      this.shared.showToast("OTP has expired. Please resend OTP.", "Error");
      return;
    }
    this.allowExit = true;
    this.LoaderService.show();
    this.submitted = true;
    if (this.emailForm.valid) {
      this.loading = true;
      let obj = {
        id: this.resData.Data || this.resData.Id,
        code: this.emailForm.value.Code,
      };
      sessionStorage.setItem('Id', obj.id);
      this.RedirectService.sendOTP(obj).subscribe((res: any) => {
        if (res.Success) {
          this.isSubmitDisabled = true;
          this.Razorpay_payment(res?.Data);
        } else if (res["ResponseCode"] == "450") {
          this.shared.showToast(this.translate.instant(messages[res["ResponseCode"]]), "Error");
          this.resendCode = true;
        } else {
          this.shared.showToast(this.translate.instant(messages[res["ResponseCode"]]), "Error");
        }
        this.LoaderService.hide();
        this.loading = false;
      });
    } else {
      this.validateForm();
      this.loading = false;
    }
  }

  Razorpay_payment(DataPay: any) {
    // --- Persist session if returned after verification ---
    if (DataPay?.AccessToken) {
      this.storageService.setItem("token", DataPay.AccessToken);
      if (DataPay.IsOnboardingPaymentPending) {
        this.storageService.setItem("IsOnboardingPaymentPending", "true");
      }
      if (DataPay.IsOnboarded === false) {
        this.storageService.setItem("InOnboarding", "true");
      }
      if (DataPay.CompanyId) this.storageService.setItem("companyId", DataPay.CompanyId);
      if (DataPay.Id) this.storageService.setItem("userId", DataPay.Id);
    }

    // --- Basic checks ---
    const storedSubsctiptionPlanId = this.storageService.getItem('selectedPlan') ? JSON.parse(this.storageService.getItem('selectedPlan')) : null;
    const plan = this.planService.getPlans().find(p => p.id === storedSubsctiptionPlanId) ?? this.planService.getPlans().find(p => p.planId === SubscriptionPlanType.BasicPlan);
    const subscriptionPlanId = plan?.id;
    this.selectedPlanId = subscriptionPlanId;

    if (plan?.planId === SubscriptionPlanType.EnterprisePlan) {
      this.shared.showToast(messages[501], "Error");
      return;
    }

    if (plan?.planId === SubscriptionPlanType.BasicPlan) {
      this.processFreePlanPayment(DataPay);
      return;
    }

    const isMonthly = JSON.parse(this.storageService.getItem('isMonth'));
    const isYearly = !isMonthly; //
    const CouponCode = this.storageService.getItem('CouponCode');

    DataPay.Id = DataPay?.Id ?? this.storageService.getItem("companyId");
    DataPay.CompanyName = DataPay?.CompanyName ?? this.storageService.getItem("CompanyName");
    DataPay.Email = DataPay?.Email ?? this.storageService.getItem("Email");
    DataPay.MobileNumber = DataPay?.MobileNumber ?? this.storageService.getItem("PhoneNumber");

    let creditValue = 0;
    if (this.shared.domainType == 'radiology' && plan) {
      let rawCredit = isYearly ? plan.annualIncludedCredits : plan.includedCredits;
      if (rawCredit) {
        creditValue = parseInt(rawCredit.toString().replace(/,/g, ''), 10);
      }
    }

    // --- Prepare request payload for backend ---
    const requestPayload = {
      CompanyId: DataPay?.Id,
      IsYearly: isYearly,
      Currency: this.storageService.getItem("selectedCurrency") ?? 'INR',
      PlanId: plan?.planId,
      IsCreateLink: true,
      AddOns: [],
      CurrencyId: this.storageService.getItem("selectedCurrencyId") ?? 1,
      CouponCode: CouponCode,
      IPAddress: this.ipAddress,
      UserId: this.storageService.getItem("userId") ?? 0,
      locationId: 1,
      SubscriptionPlanId: subscriptionPlanId,
      CreditValue: creditValue
    };

    this.LoaderService.show();
    this.stripeService.CreateRecurringSubscription(requestPayload).subscribe({
      next: (res: any) => {

        DataPay.razorpayPlanSubscriptionId = res.razorpayPlanSubscriptionId;
        DataPay.razorpayPlanId = res.razorpayPlanId;
        DataPay.razorpayCustomerId = res.razorpayCustomerId;
        DataPay.rzpOfferId = res.rzpOfferId ?? null;
        this.openPlanPayment(DataPay, requestPayload);
      },
      error: (err) => {
        console.error('Razorpay order creation failed:', err);
        this.shared.showToast("Something went wrong", "Error");
      }
    });
  }

  // Step 1: Open Razorpay for PLAN payment
  private openPlanPayment(
    DataPay: any, requestPayload: any
  ) {
    const company_logo = this.getCompanyLogo();
    const fullName = `${DataPay?.FirstName ?? ''} ${DataPay?.LastName ?? ''}`.trim();
    const planName = this.storageService.getItem("SelectedPlanName") ?? '';
    const isYearly = JSON.parse(this.storageService.getItem('isMonth'));

    const originalPrice = parseFloat(this.storageService.getItem('planPrice') ?? '0');
    const discountAmount = parseFloat(this.storageService.getItem('discountAmount') ?? '0');
    const finalPrice = discountAmount > 0
      ? parseFloat((originalPrice - discountAmount).toFixed(2))
      : originalPrice;
    const currency = this.storageService.getItem("selectedCurrency") ?? 'INR';
    const priceLabel = discountAmount > 0
      ? `${currency} ${finalPrice.toFixed(2)} (${currency} ${discountAmount.toFixed(2)} off)`
      : `${currency} ${finalPrice.toFixed(2)}`;

    const planOptions: any = {
      key: environment.razorpayTestKey,
      name: DataPay?.CompanyName,
      description: `Plan Payment — ${planName} ${isYearly ? '(Yearly)' : '(Monthly)'} | ${priceLabel}`,
      image: company_logo,
      prefill: {
        name: fullName,
        email: DataPay?.Email,
        contact: DataPay?.MobileNumber
      },
      notes: {
        payment_for: "Plan Subscription",
        plan_name: planName,
        cycle: isYearly ? 'Yearly' : 'Monthly'
      },
      currency: this.storageService.getItem("selectedCurrency") ?? 'INR',
      subscription_id: DataPay.razorpayPlanSubscriptionId, // plan subscription
      theme: { color: "#044B4F" },
      ...(DataPay?.rzpOfferId && { offer_id: DataPay.rzpOfferId }),
      handler: (planPaymentResponse: any) => {
        this.matdialogfailedRef.closeAll();
        DataPay.planPaymentId = planPaymentResponse?.razorpay_payment_id;
        // Plan payment done — open addon selection popup
        this.openAddonSelectionPopup(DataPay, requestPayload);
      },
      modal: {
        ondismiss: () => {
          this.allowExit = true;
          this.matdialogfailedRef.closeAll();
          let sessionStorageData = JSON.stringify({
            isForOTPVerifiedFlow: true,
            isAutoRenew: requestPayload?.IsAutoPay,
            CompanyId: requestPayload?.CompanyId
          });
          sessionStorage.setItem(
            'razorpay_redirect_flow',
            sessionStorageData
          );
          this.ngZone.run(() => {
            this.bypassingOtp = false; // Reset loading state
            this._router.navigate(['/Dashboard'], { replaceUrl: true }).then(success => {
              if (!success) {
                window.location.hash = "/Dashboard";
              }
            });
          });
          // Secondary fallback for external script context
          setTimeout(() => {
            if (!window.location.hash.includes('Dashboard')) {
              window.location.hash = "/Dashboard";
            }
            // Force a reload if we are still on the same page after 1s
            setTimeout(() => {
              if (window.location.hash.includes('EmailVerification')) {
                window.location.reload();
              }
            }, 1000);
          }, 300);
        }
      }
    };

    this.LoaderService.hide();
    const rzp = new Razorpay(planOptions);
    rzp.open();

    rzp.on('payment.failed', () => this.handlePlanPaymentFailed());
  }

  // Step 2: After plan payment — open addon selection popup
  private openAddonSelectionPopup(DataPay: any, requestPayload: any): void {
    const planName = this.storageService.getItem("SelectedPlanName") ?? '';
    const isYearly = !JSON.parse(this.storageService.getItem('isMonth') ?? 'false');
    const plan = this.planService.getPlans().find(p => p.id === this.selectedPlanId);
    let planAmount = plan ? this.planService.getPlanPrice(plan, isYearly) : 0;
    if (isYearly) planAmount = planAmount * 12;

    const dialogRef = this.dialog.open(AddOnPurchaseComponent, {
      panelClass: "popup_custom_width_small",
      disableClose: false,
      autoFocus: false,
      data: { isSelectionOnly: true, planName, planAmount, isYearly }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.addOnDetails?.length > 0) {
        this.createAndPayAddonSubscription(DataPay, requestPayload, result.addOnDetails);
      } else {
        // User dismissed or skipped add-ons — finalize with plan only
        this.initializePayment(DataPay?.Id);
      }
    });
  }

  // Step 3: Create addon subscription then open Razorpay for addon payment
  private createAndPayAddonSubscription(DataPay: any, requestPayload: any, addOnDetails: any[]): void {
    const addonPayload = {
      CompanyId: DataPay?.Id,
      IsYearly: requestPayload.IsYearly,
      Currency: requestPayload.Currency,
      PlanId: requestPayload.PlanId,
      CurrencyId: requestPayload.CurrencyId,
      SubscriptionPlanId: requestPayload.SubscriptionPlanId,
      AddOns: addOnDetails,
      UserId: requestPayload.UserId,
      IPAddress: this.ipAddress,
      locationId: 1
    };

    this.LoaderService.show();
    this.stripeService.CreateAddonOnlySubscription(addonPayload).subscribe({
      next: (res: any) => {
        DataPay.razorpayAddonPlanSubscriptionId = res.razorpayAddonPlanSubscriptionId;
        const fullName = `${DataPay?.FirstName ?? ''} ${DataPay?.LastName ?? ''}`.trim();
        this.openAddonPayment(DataPay, fullName, this.getCompanyLogo(), addOnDetails);
      },
      error: () => {
        this.LoaderService.hide();
        this.shared.showToast("Failed to setup add-on subscription. Proceeding without add-ons.", "Error");
        this.initializePayment(DataPay?.Id);
      }
    });
  }

  // Step 4: Open Razorpay for ADDON payment
  private openAddonPayment(DataPay: any, fullName: string, company_logo: string, selectedAddOns: any[]): void {
    let addonPaymentHandled = false;
    const isYearly = JSON.parse(this.storageService.getItem('isMonth') ?? 'false');
    const addonNames = selectedAddOns
      .filter((a: any) => (a.AddOnQty ?? a.quantity ?? 0) > 0)
      .map((a: any) => {
        const typeName = a.TypeName || this.getFallbackAddonName(a.AddOnTypeId ?? a.id);
        return `${typeName} x${a.AddOnQty ?? a.quantity}`;
      })
      .join(', ');

    const addonOptions: any = {
      key: environment.razorpayTestKey,
      name: DataPay?.CompanyName,
      description: `Add-on Payment — ${addonNames || 'Add-ons'} ${isYearly ? '(Yearly)' : '(Monthly)'}`,
      image: company_logo,
      prefill: {
        name: fullName,
        email: DataPay?.Email,
        contact: DataPay?.MobileNumber
      },
      currency: this.storageService.getItem("selectedCurrency") ?? 'INR',
      subscription_id: DataPay.razorpayAddonPlanSubscriptionId,
      theme: { color: "#044B4F" },
      notes: {
        payment_for: "Addon Subscription",
        addons: addonNames,
        cycle: isYearly ? 'Yearly' : 'Monthly'
      },
      modal: {
        ondismiss: () => {
          if (!addonPaymentHandled) {
            addonPaymentHandled = true;
            this.handleAddonPaymentFailed(DataPay);
          }
        }
      },
      handler: (addonPaymentResponse: any) => {
        addonPaymentHandled = true;
        this.matdialogfailedRef.closeAll();
        DataPay.addonPaymentId = addonPaymentResponse?.razorpay_payment_id;
        DataPay.addonSubscriptionId = addonPaymentResponse?.razorpay_subscription_id;
        this.initializePayment(DataPay?.Id);
      }
    };

    this.LoaderService.hide();
    const addonRzp = new Razorpay(addonOptions);
    addonRzp.open();
    addonRzp.on('payment.failed', () => {
      if (!addonPaymentHandled) {
        addonPaymentHandled = true;
        this.handleAddonPaymentFailed(DataPay);
      }
    });
  }

  // Handle plan payment failed
  private handlePlanPaymentFailed() {
    if (!this.isPaymentFailedDialogOpen) {
      this.isPaymentFailedDialogOpen = true;
      const dialogRef = this.matdialogRef = this.dialog.open(this.paymentfailedDialog, {
        disableClose: true,
        panelClass: "popup_custom_width_small",
        autoFocus: false
      });
      dialogRef.afterClosed().subscribe(() => {
        this.isPaymentFailedDialogOpen = false;
      });
    }
  }

  // Handle addon payment failed — plan already paid, proceed without add-ons
  private handleAddonPaymentFailed(DataPay: any) {
    const dialogRef = this.dialog.open(this.addonFailedDialog, {
      disableClose: true,
      panelClass: "popup_custom_width_small",
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(() => {
      this.initializePayment(DataPay?.Id);
    });
  }

  private getCompanyLogo(): string {
    const dashboardLogo = this.storageService.getItem("DashboardLogo");
    if (dashboardLogo && dashboardLogo.trim().length > 0) {
      return dashboardLogo;
    }

    // Fallback to domain-wise default logos
    const origin = window.location.origin;
    const domain = this.shared.domainType;
    let logoPath = 'assets/media/logos/plus_physio_Logo.png'; // default

    if (domain === 'doctor') {
      logoPath = 'assets/media/logos/PlusDoctorLogo.png';
    } else if (domain === 'radiology') {
      logoPath = 'assets/media/logos/Plus-Radiology.png';
    }

    return `${origin}/${logoPath}`;
  }

  private getFallbackAddonName(typeId: number): string {
    const names = {
      1: 'User',
      2: 'Location',
      3: 'Patients',
      4: 'Storage',
      5: 'Whatsapp'
    };
    return names[typeId] || 'Add-on';
  }

  processFreePlanPayment(DataPay: any) {
    const isFromOnboarding = this.storageService.getItem('isFromOnboarding') === 'true';
    if (isFromOnboarding) {
      this.allowExit = true;
      const companyDomain = DataPay['Data']?.companyDOmainName;
      this.domainService.setDomain(companyDomain);
      this.matdialogfailedRef.closeAll();
      this.storageService.removeItem('IsOnboardingPaymentPending');
      this.storageService.removeItem('InOnboarding');
      this.AdminUserLogin(DataPay?.Id, isFromOnboarding);
    } else {
      this.initializePayment(DataPay);
    }
  }

  // --- Helper function to get plan key for environment ---
  selectedPlanKey(Plan_id: number): string {
    const isUSD = this.storageService.getItem('selectedCurrency') === 'USD';
    const plan = this.planService.getPlans().find(p => p.id === Plan_id);
    switch (plan?.planId) {
      case SubscriptionPlanType.StandardPlan: return isUSD ? 'standardUSD' : 'standard';
      case SubscriptionPlanType.PremiumPlan: return isUSD ? 'premiumUSD' : 'premium';
      default: return isUSD ? 'premiumUSD' : 'premium'; // fallback
    }
  }

  getpaymentDetail() {
    this.service.getpaymentDetailforsignup(this.sessionId, 2).subscribe((response) => {
      if (response == true) {
        this.paymentDetail = response["Data"];
      }
    });
  }

  /// Razor pay Payment Start
  initializePayment(
    Id: any,
  ) {
    this.LoaderService.show();
    this.handleSuccessfulPayment(Id);
  }

  private handleSuccessfulPayment(Id: any) {
    const isFromOnboarding = this.storageService.getItem('isFromOnboarding') === 'true';
    this.storageService.clear();
    sessionStorage.clear();
    sessionStorage.removeItem("PatientList");
    this.matdialogfailedRef.closeAll();

    if (isFromOnboarding) {
      this.allowExit = true;
      this.storageService.removeItem('IsOnboardingPaymentPending');
      this.storageService.removeItem('InOnboarding');
      this.AdminUserLogin(Id, isFromOnboarding);
    } else {
      this._router.navigate(['/login']);
    }
  }

  AdminUserLogin(data: any, isFromOnboarding: boolean = false) {
    this.RedirectService.AdminLoginData(data, isFromOnboarding).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.storageService.setItem("clickhere", JSON.stringify(true));
          this.storageService.setItem("token", res["AccessToken"]);
          this.storageService.setItem("Name", res["Data"].Name);
          this.storageService.setItem("userId", res["Data"].Id);
          this.storageService.setItem("companyId", res["Data"].CompanyId);
          this.storageService.setItem("CompanyName", res["Data"].CompanyName);
          this.storageService.setItem("DoctorTypeId", res["Data"].DoctorTypeId);
          this.storageService.setItem("Location", res["Data"].LocationId);
          this.storageService.setItem("AspNetRole", res["Data"].AspNetRoleList);
          this.storageService.setItem("IsFirst", res["Data"].IsFirst);
          this.storageService.setItem("IsTour", res["Data"].IsTour);
          this.storageService.setItem("UserName", res["Data"].UserName);
          this.storageService.setItem("IsAutoRenewActive", res["Data"].IsAutoRenewActive);
          if (isFromOnboarding) {
            this.storageService.setItem("IsAdmin", true);
            this.storageService.setItem("AdminLoginUserId", res["Data"].Id);
            // Set TermAndConditionInfo so app.component's checkAndOpenTermsDialog / LoadTour can fire
            const termInfo = {
              AgreeTerms: res["Data"].AgreeTerms ?? false,
              SkipTermsCount: res["Data"].SkipTermsCount ?? 0
            };
            this.storageService.setItem("TermAndConditionInfo", JSON.stringify(termInfo));
          }
          this.featureAccessService.setFeature(res["Data"].SubscriptionAccesses);
          const redirectMenu = res["Data"]?.RedirectMenu;
          this.redirectMenu = redirectMenu && redirectMenu.trim().length > 0 ? redirectMenu : "Dashboard";
          this.storageService.setItem(
            "selectedPlan",
            res["Data"].selectedPlan ?? this.selectedPlanId?.toString()
          );
          this.storageService.setItem(
            "Location",
            JSON.stringify({
              Id: res["Data"].LocationId,
              Name: res["Data"].LocationName,
            })
          );
          this.redirect.getDefaultLocation(res["Data"].Id).subscribe({
            next: (response: any) => {
              if (response["Data"] != null && response["Success"] === true) {
                this.storageService.setItem(
                  "Location",
                  JSON.stringify({
                    Id: res["Data"].LocationId,
                    Name: res["Data"].LocationName,
                  })
                );
              }
              this.getFormat(res["Data"].CompanyId);
            },
          });
        }
        else {
          this.shared.showToast("Something went wrong in the login process sorry", "Error");
        }

      }, error: () => {
        this.shared.showToast("Something went wrong in the login process sorry", "Error");
      }
    })
  }

  async getFormat(id: any) {
    try {
      const res: any = await this.shared.getCompanyByIdpromise(id);

      if (!res?.Success) {
        this.handleError();
        return;
      }

      const data = res.Data;

      if (!data?.CurrencyObj?.CurrencySymbol) {
        this.handleError();
        return;
      }

      // Set currency & WhatsApp display
      this.storageService.setItem("Currency", data.CurrencyObj.CurrencySymbol);
      this.storageService.setItem("IsWhatsAppDisplay", data.IsWhatsAppDisplay);

      // Get redirect data
      //const response: any = await this.RedirectService.getAll(id).toPromise();
      const response: any = await firstValueFrom(this.RedirectService.getAll(id));
      if (response?.Success) {
        const responseData = response.Data ?? [];

        responseData.forEach((item: any) => {
          if (item.Key === 'CompanyDateFormat') {
            localStorage.setItem(item.Key, item.Value);
          }
          else if (item.Key === 'CustomTimePickerFormat') {
            const timeformat = item.Value === '12 hours' ? 'hh:mm a' : 'HH:mm';
            this.storageService.setItem('TimeFormat', timeformat);
          }
          else {
            this.storageService.setItem(item.Key, item.Value);
          }
        });
      }

      // Navigation
      this.menuHorService.setPath(this.redirectMenu);
      this._router.navigate([this.redirectMenu]);

    } catch (error) {
      console.error("Error in getFormat:", error);
      this.handleError();
    } finally {
      this.LoaderService.hide();
    }
  }

  ResendCode() {
    if (this.isResendDisabled) return;
    this.isResendDisabled = true;
    this.LoaderService.show();
    let obj = {
      id: this.resData?.Data ?? this.resData?.Id,
    };
    this.RedirectService.resendOTPforRegister(obj).subscribe((res: any) => {
      if (res.Success) {
        sessionStorage.setItem("Res", JSON.stringify(res));
        this.shared.showToast(
          this.translate.instant("OTP Sent successfully"),
          "Success"
        );
        this.emailForm.reset();
        this.startResendTimer(true);
        this.setOtpExpiryTime(true);
        this.resendCode = false;
        this.loadingResend = false;
        this.isResendDisabled = false;
      } else {
        this.shared.showToast(this.translate.instant(messages[res["ResponseCode"]]), "Error");
        this.loadingResend = false;
      }
      this.LoaderService.hide();
    });
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
      .toString()
      .padStart(2, '0')}`;
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  startResendTimer(isResend: boolean = false) {
    let storedTimer = Number.parseInt(this.storageService.getItem('resendTimer'));
    if (storedTimer && !Number.isNaN(storedTimer) && storedTimer > 0 && !isResend) {
      this.resendTimer = storedTimer;
    } else if (isResend || (this.navigationState && this.navigationState.navigationId != 1)) {
      this.resendTimer = 90;
      this.storageService.setItem('resendTimer', this.resendTimer.toString());
    }
    else
      return;

    this.isResendDisabled = true;
    this.otpExpired = false;

    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.timerInterval = setInterval(() => {
      this.resendTimer--;
      if (this.resendTimer <= 0) {
        this.isResendDisabled = false;
        clearInterval(this.timerInterval);
        this.storageService.removeItem('resendTimer');
      }
      this.storageService.setItem('resendTimer', this.resendTimer.toString());
    }, 1000);
  }

  setOtpExpiryTime(isResend: boolean = false) {
    let storedExpiryTimer = Number.parseInt(this.storageService.getItem('otpExpiryTime'));
    if (storedExpiryTimer && !Number.isNaN(storedExpiryTimer) && storedExpiryTimer > 0 && !isResend) {
      this.otpExpiryTime = storedExpiryTimer;
    }
    else if (isResend) {
      this.otpExpiryTime = 300;
      this.storageService.setItem('otpExpiryTime', this.otpExpiryTime.toString());
    }

    if (this.expiryTimerInterval) {
      clearInterval(this.expiryTimerInterval);
    }

    this.expiryTimerInterval = setInterval(() => {
      this.otpExpiryTime--;
      if (this.otpExpiryTime <= 0) {
        this.isResendDisabled = false;
        clearInterval(this.expiryTimerInterval);
        this.otpExpired = true;
        this.storageService.removeItem('otpExpiryTime');
      }
      this.storageService.setItem('otpExpiryTime', this.otpExpiryTime.toString());
    }, 1000);
  }

  canExitResetPage(): boolean {
    if (location.href.includes('/login') || location.href.includes('/Login')) {
      return true;
    }
    return this.allowExit;
  }

  otpControls = Array(6).fill(0);
  otpValues: string[] = ["", "", "", "", "", ""];

  onInput(event: any, index: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/\D/g, ''); // only numbers

    if (value) {
      this.otpValues[index] = value;
      if (index < 5) {
        const nextInput = document.getElementById('otp-' + (index + 1)) as HTMLInputElement;
        nextInput?.focus();
      }
    } else {
      input.value = '';
      this.otpValues[index] = '';
    }

    this.emailForm.patchValue({ Code: this.otpValues.join('') });
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && !input.value && index > 0) {
      const prevInput = document.getElementById('otp-' + (index - 1)) as HTMLInputElement;
      prevInput?.focus();
    }
  }

  onPaste(event: ClipboardEvent): void {
    const pasteData = event.clipboardData?.getData('text')?.trim() ?? '';
    const inputs = document.querySelectorAll<HTMLInputElement>('.otp-input');

    // Allow paste of 1–6 digits
    if (pasteData && /^\d{1,6}$/.test(pasteData)) {
      pasteData.split('').forEach((char, i) => {
        if (inputs[i]) {
          inputs[i].value = char;
          this.otpValues[i] = char;
        }
      });

      // Focus next empty box (or last one if all filled)
      const nextIndex = Math.min(pasteData.length, inputs.length - 1);
      inputs[nextIndex].focus();

      this.emailForm.patchValue({ Code: this.otpValues.join('') });

      // Auto-submit if all 6 digits are filled
      if (pasteData.length === 6) {
        setTimeout(() => this.clickme(), 200); // slight delay for form sync
      }
    }

    event.preventDefault();
  }

  private handleError() {
    this.shared.showToast(this.translate.instant("common.errMsg"), "Error");
  }

  checkJobStatus(jobId: string, dataPay: any) {
    this.RedirectService.getJobStatus(jobId).subscribe({
      next: (jobRes: any) => {
        if (jobRes.Success && jobRes.Data && jobRes.Data.Status === 2) { // 2 = Completed
          this.Razorpay_payment(dataPay);
        } else {
          setTimeout(() => this.checkJobStatus(jobId, dataPay), 3000);
        }
      },
      error: () => {
        setTimeout(() => this.checkJobStatus(jobId, dataPay), 3000);
      }
    });
  }
}
